import _regeneratorRuntime from "babel-runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from "react";
import PropTypes from "prop-types";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";
import CloseButton from "../Misc/CloseButton";
import Button from "../Misc/Buttons/DefaultBlueButton";
import { withProvider, consumeContext } from "./EditorContext";
import * as OverlayContext from "./OverlayContext";
import ProcessingModal from "../Misc/ProcessingModal";
import Video from "./Video";
import HelpPopup from "./HelpPopup";
import OverlaySettingsModal from "./OverlaySettingsModal";
import TimeRangeSelector from "./TimeRangeSelector";
import Toolbar from "./Toolbar";
import ScriptText from "./ScriptText";
import DragLayer from "./DragLayer";
import TouchBackend from "react-dnd-touch-backend";
import MouseBackEnd from "react-dnd-mouse-backend";
import { debounce } from "../Misc/Utils";

function isTouchDevice() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

function isWindowsChrome() {
  var isChrome = navigator.userAgent.indexOf("Chrome") !== -1;
  var isWindows = navigator.userAgent.indexOf("Windows") !== -1;
  return isChrome && isWindows;
}

var VideoEditor = function (_Component) {
  _inherits(VideoEditor, _Component);

  function VideoEditor() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isSaving: false
    }, _this.handleClose = function () {
      _this.props.onClose();
    }, _this.handleSave = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this$props, onSave, OverlayContext;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.state.isSaving) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _this.setState({
                isSaving: true
              });

              _this$props = _this.props, onSave = _this$props.onSave, OverlayContext = _this$props.OverlayContext;
              _context.prev = 4;
              _context.next = 7;
              return onSave(OverlayContext.state.overlay, _this.getSelectedFrame());

            case 7:
              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](4);

            case 11:
              _this.setState({
                isSaving: false
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[4, 9]]);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  VideoEditor.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var _props = this.props,
        EditorContext = _props.EditorContext,
        OverlayContext = _props.OverlayContext,
        videoSrc = _props.videoSrc,
        assetsSource = _props.assetsSource,
        supportSearch = _props.supportSearch,
        assetsFilters = _props.assetsFilters,
        _props$overlay = _props.overlay,
        overlay = _props$overlay === undefined ? null : _props$overlay,
        framesSource = _props.framesSource,
        selectedFrame = _props.selectedFrame,
        rest = _objectWithoutProperties(_props, ["EditorContext", "OverlayContext", "videoSrc", "assetsSource", "supportSearch", "assetsFilters", "overlay", "framesSource", "selectedFrame"]);

    EditorContext.initializeState(_extends({
      video: {
        src: videoSrc
      },
      assets: {
        assetsSource: assetsSource,
        supportSearch: supportSearch,
        assetsFilters: assetsFilters
      },
      frames: {
        framesSource: framesSource,
        selectedFrame: selectedFrame
      }
    }, rest));

    if (EditorContext.frames.hasFrames()) {
      EditorContext.frames.loadFrames();
    }

    var onOverlayChange = debounce(_asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _props2, onAutoSave, OverlayContext;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _props2 = _this3.props, onAutoSave = _props2.onAutoSave, OverlayContext = _props2.OverlayContext;

              if (onAutoSave) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _this3.setState({
                isSaving: true,
                isAutoSave: true
              });

              _context2.prev = 4;
              _context2.next = 7;
              return onAutoSave(OverlayContext.state.overlay, _this3.getSelectedFrame());

            case 7:
              _context2.next = 11;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](4);

            case 11:
              _this3.setState({
                isSaving: false,
                isAutoSave: false
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[4, 9]]);
    })), (this.props.autoSaveDelay || 5) * 1000);
    OverlayContext.initializeState({
      overlay: overlay,
      onOverlayChange: onOverlayChange
    }, EditorContext);
    OverlayContext.rememberOverlay(function () {
      return EditorContext.frames.selectFrame(selectedFrame);
    });
  };

  VideoEditor.prototype.getSelectedFrame = function getSelectedFrame() {
    var frames = this.props.EditorContext.frames;

    if (!frames.hasFrames()) {
      return null;
    }

    var _frames$getFrames = frames.getFrames(),
        _frames$getFrames$fra = _frames$getFrames.frames,
        framesList = _frames$getFrames$fra === undefined ? [] : _frames$getFrames$fra,
        selectedFrameId = _frames$getFrames.selectedFrame;

    return framesList.find(function (frame) {
      return frame.id === selectedFrameId;
    });
  };

  VideoEditor.prototype.render = function render() {
    var EditorContext = this.props.EditorContext;
    var video = EditorContext.state.video;
    return React.createElement("div", {
      className: "recorder recorder--style-edit-asset video-editor"
    }, React.createElement(ProcessingModal, {
      active: !video.props,
      title: "Loading video",
      text: "Please wait few seconds until finished."
    }), React.createElement(ProcessingModal, {
      active: this.state.isSaving,
      title: this.state.isAutoSave ? "Auto save video" : "Processing video",
      text: "Please wait few seconds until finished."
    }), React.createElement(CloseButton, {
      closeHandler: this.handleClose
    }), React.createElement(Button, {
      className: "recorder__save",
      onClick: this.handleSave
    }, "save"), React.createElement(OverlaySettingsModal, null), React.createElement("div", {
      className: "video-player video-player--style-recorder"
    }, React.createElement("div", {
      className: "video-player__container",
      style: {
        width: "100%",
        height: "100%"
      }
    }, React.createElement(Video, null), React.createElement(DragLayer, {
      scale: video.scale
    }), React.createElement(ScriptText, null)), React.createElement(TimeRangeSelector, null)), React.createElement(Toolbar, null), React.createElement(HelpPopup, null));
  };

  return VideoEditor;
}(Component);

VideoEditor.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired,
  OverlayContext: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  videoSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  scriptText: PropTypes.string,
  tutorialLink: PropTypes.string,
  assetsSource: PropTypes.func,
  supportSearch: PropTypes.bool,
  assetsFilters: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    filter: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    supportSearch: PropTypes.bool,
    uploadAssets: PropTypes.func,
    deleteAsset: PropTypes.func
  })),
  availableFonts: PropTypes.array,
  logo: PropTypes.shape({
    url: PropTypes.string.isRequired,
    size: PropTypes.string,
    bottom: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number,
    left: PropTypes.number
  }),
  framesSource: PropTypes.func,
  selectedFrame: PropTypes.string,
  overlay: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onAutoSave: PropTypes.func,
  autoSaveDelay: PropTypes.number
} : {};
var TouchBackendEditor = DragDropContext(TouchBackend)(withProvider(consumeContext(OverlayContext.withProvider(OverlayContext.consumeContext(VideoEditor)))));
var HTML5BackendEditor = DragDropContext(HTML5Backend)(withProvider(consumeContext(OverlayContext.withProvider(OverlayContext.consumeContext(VideoEditor)))));
var MouseBackendEditor = DragDropContext(MouseBackEnd)(withProvider(consumeContext(OverlayContext.withProvider(OverlayContext.consumeContext(VideoEditor)))));
export default (function (_ref3) {
  var enableWindowsChromeWorkaround = _ref3.enableWindowsChromeWorkaround,
      rest = _objectWithoutProperties(_ref3, ["enableWindowsChromeWorkaround"]);

  if (isTouchDevice()) {
    return React.createElement(TouchBackendEditor, rest);
  }

  return React.createElement(HTML5BackendEditor, rest);
});